import { ArrowUpRight } from "lucide-react";
import { LineReveal, FadeUp } from "../components/RevealText";

const LINKS = [
  { label: "MSCA", desc: "Mechanical Service Contractors of America", url: "http://www.mcaa.org/msca/" },
  { label: "SMACNA", desc: "Sheet Metal & Air Conditioning Contractors' National Association", url: "http://www.smacna.org/" },
  { label: "ASHRAE", desc: "American Society of Heating, Refrigerating and Air-Conditioning Engineers", url: "http://www.ashrae.org/" },
  { label: "ACCA", desc: "Air Conditioning Contractors of America", url: "http://www.acca.org/" },
  { label: "SPIDA", desc: "Spiral Duct Manufacturers Association", url: "http://www.spida.org/" },
];

export default function Links() {
  return (
    <main data-testid="links-page" className="bg-black text-white pt-24">
      <section className="border-b border-white/10 px-4 md:px-6 py-12 md:py-16">
        <h1 className="font-display font-bold text-6xl md:text-8xl leading-[0.9] uppercase">
          <LineReveal delay={0.15}>Links</LineReveal>
        </h1>
      </section>

      <section data-testid="links-list" className="border-b border-white/10 px-4 md:px-6">
        {LINKS.map((item, i) => (
          <FadeUp key={item.label} delay={i * 0.06}>
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`link-${item.label.toLowerCase()}`}
              className="group grid grid-cols-12 gap-6 border-b border-white/10 py-8 md:py-10 items-baseline transition-colors duration-500 hover:bg-white/[0.03]"
            >
              <div className="col-span-12 md:col-span-4">
                <p className="font-display text-5xl md:text-7xl leading-none transition-transform duration-500 group-hover:translate-x-2">
                  {item.label}
                </p>
              </div>
              <div className="col-span-11 md:col-span-7 text-white/60 text-base md:text-lg">
                {item.desc}
              </div>
              <div className="col-span-1 flex justify-end">
                <ArrowUpRight
                  strokeWidth={1.5}
                  className="w-6 h-6 md:w-8 md:h-8 text-white/50 transition-all duration-500 group-hover:text-white group-hover:-translate-y-1 group-hover:translate-x-1"
                />
              </div>
            </a>
          </FadeUp>
        ))}
      </section>
    </main>
  );
}
